import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ColorModeIconDropdown from '../shared-theme/ColorModeIconDropdown';
import logoCabanaWhite from '../images/logonext-white.svg'
import logoCabanaBlack from '../images/logonext-dark.svg'
import { useColorScheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const StyledToolbar = styled(Toolbar)(({ theme }: any) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);
  const { mode, systemMode } = useColorScheme();
  const navigate = useNavigate();

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <img
              src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
              alt="logo-cabanalink"
              onClick={() => navigate('/')}
              style={{ 
                width: '100px', 
                height: 'auto', 
                marginRight: '20px',
                cursor: 'pointer',
              }}
            />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Button
                component="a"
                variant="text"
                color="info"
                size="small"
                href="/"
              >
                Início
              </Button>
              <Button
                component={HashLink}
                variant="text"
                color="info"
                size="small"
                to="/#testimonials"
                smooth
              >
                Depoimentos
              </Button>
              <Button
                component={HashLink}
                variant="text"
                color="info"
                size="small"
                to="/#pricing"
                smooth
              >
                Planos
              </Button>
              <Button
                component={HashLink}
                variant="text"
                color="info"
                size="small"
                to="/#faq"
                smooth
              >
                FAQs
              </Button>
              <Button
                component="a"
                variant="text"
                color="info"
                size="small"
                href="/about-us"
              >
                Sobre
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Button color="primary" variant="text" size="small" onClick={() => navigate('/signin')}>
              Entrar
            </Button>
            <Button color="primary" variant="contained" size="small" onClick={() => navigate('/signup')}>
              Cadastrar
            </Button>
            <ColorModeIconDropdown />
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            <ColorModeIconDropdown size="medium" />
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  top: 'var(--template-frame-height, 0px)',
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                  <Button
                    component="a"
                    href="/"
                  >
                    Início
                  </Button>
                  <Button
                    component={HashLink}
                    variant="text"
                    color="info"
                    size="small"
                    to="/#testimonials"
                    smooth
                    onClick={toggleDrawer(false)}
                  >
                    Depoimentos
                  </Button>
                  <Button
                    component={HashLink}
                    variant="text"
                    color="info"
                    size="small"
                    to="/#pricing"
                    smooth
                    onClick={toggleDrawer(false)}
                  >
                    Planos
                  </Button>
                  <Button
                    component={HashLink}
                    variant="text"
                    color="info"
                    size="small"
                    to="/#faq"
                    smooth
                    onClick={toggleDrawer(false)}
                  >
                    Dúvidas Frequentes
                  </Button>
                  <Button
                    component="a"
                    href="/about-us"
                  >
                    Sobre
                  </Button>
                </Box>
                <Divider sx={{ my: 3 }} />
                <MenuItem>
                  <Button color="primary" variant="contained" fullWidth onClick={() => navigate('/signup')}>
                    Cadastrar
                  </Button>
                </MenuItem>
                <MenuItem>
                  <Button color="primary" variant="outlined" fullWidth onClick={() => navigate('/signin')}>
                    Entrar
                  </Button>
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}